import MCardFilter from './index.vue';

MCardFilter.install = app => {
  app.component(MCardFilter.name, MCardFilter);
};

export default MCardFilter;
